module.exports = __webpack_public_path__ + "img/down-arrow.80f809f7.svg";